import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import Select from 'react-select';
import { toast } from "react-toastify";

class   BookForm extends Component{

    state = {
        id : null,
        authorId : "",
        spotId : "",
        title : "",
        edition : "",
        year : "",
        page : "",
        error : "",
        
        isModal : false,
        title : null,
        authors : [],
        spots : [],
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    async authors (){
        var authors = await axios.get('authors');
        if(authors.status === 200)
        {
            this.setState({
                authors : authors.data
            })
        }
    }

    async spots (){
        var spots = await axios.get('spots');
        if(spots.status === 200)
        {
            this.setState({
                spots : spots.data
            })
        }
    }

    storeAuthor = () =>{
        var data = {
                authorId : this.state.authorId,
                spotId : this.state.spotId,
                title : this.state.title,
                edition : this.state.edition,
                year : this.state.year,
                page : this.state.page,
            }
            
        var request = this.state.id ? axios.put('books/'+this.state.id, data) : axios.post('books', data);
        request.then((response) =>{
            this.props.showModal()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }
    
    edit=()=>  {
        this.form()
        this.authors()
        this.spots()
    }

    form=()=>{
        this.setState({
            id: this.props.formData ? this.props.formData.id : "",
            authorId: this.props.formData ? this.props.formData.authorId : null,
            spotId: this.props.formData ? this.props.formData.spotId : null,
            title: this.props.formData ? this.props.formData.title : "",
            page: this.props.formData ? this.props.formData.page : null,
            edition: this.props.formData ? this.props.formData.edition : "",
            year: this.props.formData ? this.props.formData.year : "",
            page: this.props.formData ? this.props.formData.page : "",
            error : "",
        })
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }

    render(){
        var optionspots = [],optionauthors = [];

        this.state.spots.map((spot) => {
            optionspots.push({ value : spot.id, label : spot.spot})
        })

        this.state.authors.map((author) => {
            optionauthors.push({ value : author.id, label : author.last_name + " " + author.first_name})
        })
        

        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <Modal.Title className="h6 font-monospace">{ "Livre"}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="row">

                    <div className="text-center"><span className="text-danger text-small small">{ this.state.error }</span></div>

                    <div className="form-group col-md-12 mt-2">
                        <label className="font-weight-bolder">Auteur</label>
                        <div className="input-group">
                            <Select className="form-control form-control-sm p-0"
                                closeMenuOnSelect={false}
                                defaultValue={[ ]}
                                isMulti
                                options={optionauthors}
                                onChange={
                                    (select) => {
                                        this.setState({
                                            authorId : select
                                        });
                                    }
                                } 
                            />
                        </div>
                    </div>

                    <div className="form-group col-md-12 mt-2">
                        <label className="font-weight-bolder">Emplacement du livre</label>
                        <div className="input-group">
                            <Select className="form-control form-control-sm p-0"
                                value = {
                                    optionspots.filter(option => 
                                    option.value == this.state.spotId)
                                }
                                defaultValue={this.state.spotId}
                                onChange={
                                    (select) => {
                                        this.setState({
                                            spotId : select.value
                                        });
                                    }
                                }
                                options={optionspots}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Titre</label>
                            <div className="position-relative mt-1">
                                <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="title"  value={this.state.title} id="nom-id-icon" />
                                <div className="form-control-icon text-primary">
                                    <FeatherIcon icon="box"></FeatherIcon>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Edition</label>
                            <div className="position-relative mt-1">
                                <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="edition"  value={this.state.edition} id="nom-id-icon" />
                                <div className="form-control-icon text-primary">
                                    <FeatherIcon icon="file"></FeatherIcon>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Page</label>
                            <div className="position-relative mt-1">
                                <input type="number" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="page"  value={this.state.page} id="nom-id-icon" />
                                <div className="form-control-icon text-primary">
                                    <FeatherIcon icon=""></FeatherIcon>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Année</label>
                            <div className="position-relative mt-1">
                                <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="year"  value={this.state.year} id="nom-id-icon" />
                                <div className="form-control-icon text-primary">
                                    <FeatherIcon icon=""></FeatherIcon>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button onClick={this.props.showModal} className="btn btn-outline-secondary btn-sm p-0 px-1"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                    <button onClick={() => this.storeAuthor()} className="btn btn-sm btn-outline-primary p-0 px-1"><FeatherIcon icon="check-square"></FeatherIcon> Sauvegarder</button>
                </Modal.Footer>
            </Modal>
            
 
        </div>
        )
    }
}
export default BookForm;